const styles = () => ({
  container: {},
  avatarImg: {
    height: '65px',
    width: '65px',
    marginRight: 12,
  },
  itemParent: {
    borderBottom: '1px solid #ccc',
  },
  listItem: {
    padding: '24px',
  },
  '@media (max-width: 600px)': {
    avatarImg: {
      height: 40,
      width: 40,
      marginRight: 12,
    },
  },
  bodyText: {
    fontSize: '14px',
  },
  lightThinLabel: {
    fontWeight: '500',
  },
  textInput: {
    width: '90%',
  },
});

export default styles;
